import styled from 'styled-components'

import { getCssFromTheme } from '../../../utils/css'

export const StyledButton = styled.button`
  ${({ theme, variant }) => getCssFromTheme(theme, 'button', variant)};
  ${({ theme, typographyVariant }) => getCssFromTheme(theme, 'typography', typographyVariant)};
  cursor: pointer;
  outline: none;
  //min-width: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ padding }) => padding || '12px 15px'};
  margin: ${({ margin }) => margin};
  box-sizing: border-box;
  white-space: nowrap;
  border-radius: ${({ borderRadius }) => borderRadius || '3px'};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border-color: ${({ borderColor }) => borderColor};
  color: ${({ color }) => color};
  max-width: ${({ maxWidth }) => maxWidth};
  
  &.withoutBorder {
    border: none;
  }

  &.uppercase {
    text-transform: uppercase;
  }

  &.small {
    min-height: 18px;
  }
  &.medium {
    min-height: 42px;
  }

  &.primary {
    &:hover:not(.disabled) {
      background-color: ${({ theme, hoverType, backgroundColor }) =>
        hoverType !== 'opacity' &&
        (backgroundColor ? `${backgroundColor}CC` : theme.color.primary[hoverType])};
    }
  }
  &.secondary {
    &:hover:not(.disabled) {
      background-color: ${({ theme, hoverType, backgroundColor }) =>
        hoverType !== 'opacity' &&
        (backgroundColor ? `${backgroundColor}CC` : theme.color.primary[hoverType])};};
    }
  }
  &.general {
    &:hover:not(.disabled) {
      background-color: ${({ theme, backgroundColor, hoverType }) =>
        hoverType !== 'opacity' && (backgroundColor ? `${backgroundColor}CC` : theme.color.general.lightest)};
    }
  }

  &:hover:not(.disabled) {
    ${({ hoverType }) => hoverType === 'opacity' && 'opacity: 0.7;'}
  }

  &.fullWidth {
    width: 100%;
  }

  &.googleButton {
    background-color: ${({ theme }) => theme.color.general.white};
    border: ${({ theme }) => `1px solid ${theme.color.general.lighter}`};
    min-width: auto !important;
    &:hover:not(.disabled) {
      background-color: ${({ theme }) => theme.color.primary.lighter};
    }
  }

  &.facebookButton {
    background-color: #1877f2;
    &:hover:not(.disabled) {
      background-color: #1877f2;
      opacity: 0.8;
    }
  }

  &.twitterButton {
    background-color: #1da1f2;
    &:hover:not(.disabled) {
      background-color: #1da1f2;
      opacity: 0.8;
    }
  }

  &.disabled {
    ${({ theme }) => getCssFromTheme(theme, 'button', 'disabled')};
    cursor: not-allowed;
    border: none;

    .icon path {
      stroke: ${({ theme }) => theme.components.button.disabled.color};
    }
  }
`
